import { render, staticRenderFns } from "./ModalMelonTV.vue?vue&type=template&id=58bf115b&"
import script from "./ModalMelonTV.vue?vue&type=script&lang=js&"
export * from "./ModalMelonTV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports